import { useEffect, useRef } from 'react';

import { getApplicableL2MyTeamModules } from 'Deer/components/navigation/secondary/MyTeam/MyTeamModules';
import { staticRoutes } from 'Deer/constants/routes';
import { useRouteToMyTeamLevels } from 'Deer/hooks/useRouteToL3';
import { useViewFromQueryParam } from 'Deer/hooks/useViewFromQueryParam';
import { GoalsIntentLandingPage } from 'Deer/intent/Goals/GoalsIntentLandingPage';
import { IntentDropdown } from 'Deer/intent/Goals/components/IntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setSelectedView } from 'reducers/viewsSlice';
import { AgGridTreeView } from 'screens/Team/Rabbit/Goals/AgGridTreeView';
import Header from 'screens/Team/Rabbit/Goals/Header';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { modifyString, StringModifier } from 'constants/copyHelpers';
import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { PageTabbedNavigationV1 } from 'uiToolkitV1/PageTabbedNavigationV1';

const ViewsManageGoals = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const gridRef = useRef();

  const { l3Options: tabs } = useRouteToMyTeamLevels();

  const { moduleName } = useOrganisationSettings();

  const { data: view, isLoading, isError } = useViewFromQueryParam();

  const applicableL2ViewModules = getApplicableL2MyTeamModules('view', moduleName);

  useEffect(() => {
    if (!isLoading) {
      const cohortToSet = {
        id: view?.id,
        name: view?.name ?? '',
        // type: tab?.type,
      };
      dispatch(setSelectedView(cohortToSet));
    }
    return () => {
      dispatch(setSelectedView({}));
    };
  }, [dispatch, isLoading, view]);

  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        page: 'Custom Team-goals-manage',
      },
    });
  }, []);

  if (isError) {
    history.replace(staticRoutes.home);
  }

  if (!isLoading && !view?.enabledFeatures.includes('GOAL')) {
    history.replace(staticRoutes.home);
  }

  if (checkIntentLandingPagesFeatureEnabled()) {
    return (
      <Layout
        Filters={
          <IntentDropdown
            gridRef={gridRef}
            breadcrumbs={{
              items: [
                {
                  label: view?.name ?? '',
                  to: `${applicableL2ViewModules[0]?.value}?viewId=${view?.id}`,
                },
              ],
              page: {
                label: modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE),
                to: '',
              },
            }}
          />
        }
      >
        <GoalsIntentLandingPage gridRef={gridRef} />
      </Layout>
    );
  }

  return (
    <>
      <Header teamName={view?.name} />
      <PageTabbedNavigationV1 tabs={tabs} />
      <AgGridTreeView showHierarchyToggle />{' '}
    </>
  );
};

export default ViewsManageGoals;
